import { HakenStaffSearchConditionForm } from '@/types/MyTask'
import { defineStore } from 'pinia'

export const useTimeSheetKakuteiShime = defineStore('TimeSheetKakuteiShime', {
  state: () => {
    return {
      item: {
        year: null,
        month: null,
        shime: null,
      } as HakenStaffSearchConditionForm,
    }
  },
  actions: {
    // 検索条件のセット
    async setItem(searchItem: HakenStaffSearchConditionForm) {
      this.item = searchItem
    },
    // 検索条件のクリア
    async removeItem() {
      this.item = {
        year: null,
        month: null,
        shime: null
      };
    }
  },
  getters: {
    searchItem(): HakenStaffSearchConditionForm {
      return this.item
    },
  }
})
